import { PropTypes } from 'prop-types';
import AccionaIcon from '../../../../../../../components/AccionaIcon';
import { useIntl } from 'react-intl';
import { Providers } from '../../../../../../../constants/providers';
import { useParams } from 'react-router-dom';

const AccionaTableButton = ({ viewAction, viewLabAction }) => {
  const { fileName } = useParams();
  const intl = useIntl();
  return (
    <>
      <tr>
        <td
          key="labelIconButton01"
          colSpan="6"
          style={{
            backgroundColor: '#e6e6e6',
            textAlign: 'center',
            width: '50%',
          }}
        >
          <label style={{ fontSize: '17px' }}>
            {intl.formatMessage({ id: 'associatedDeliveryNote' })}
          </label>
        </td>
        <td
          key="labelIconButton02"
          colSpan="6"
          style={{
            backgroundColor: '#e6e6e6',
            textAlign: 'center',
            width: '50%',
          }}
        >
          <label style={{ fontSize: '17px' }}>
            {intl.formatMessage({ id: 'scan.document.laboratory' })}
          </label>
        </td>
      </tr>
      <tr>
        <td
          key="iconButton01"
          colSpan="6"
          style={{ textAlign: 'center', height: '75px' }}
        >
          <AccionaIcon
            id="icon-delivery"
            className="btn btn-red"
            onClick={() => viewAction()}
            classIcon="icon fas fa-file-invoice"
            style={{ width: '80px', height: '50px' }}
            styleIcon={{ transform: 'scale(1.5)' }}
          />
        </td>
        <td
          key="iconButton02"
          colSpan="6"
          style={{ textAlign: 'center', height: '75px' }}
        >
          <AccionaIcon
            id="icon-scanned"
            className="btn btn-red"
            onClick={() => viewLabAction()}
            classIcon="icon fas fa-file-invoice"
            style={{ width: '80px', height: '50px' }}
            styleIcon={{ transform: 'scale(1.5)' }}
            disabled={fileName === 'cemosa.png'}
          />
        </td>
      </tr>
    </>
  );
};

AccionaTableButton.propTypes = {
  viewAction: PropTypes.func.isRequired,
  viewLabAction: PropTypes.func.isRequired,
  provider: PropTypes.oneOf([...Object.values(Providers), 'OTHER']).isRequired,
};

export default AccionaTableButton;
